import type { ApiRoute, NoQueryParams } from "../../../api"
import type { InventoryInformationChange } from "../../../inventoryInformation/InventoryInformationChange"
import type { InventoryInformationView } from "../../../inventoryInformation/InventoryInformationView"

export interface UpdateInventoryInformationPathParams {
	inventoryId: string
}

export const updateInventoryInformationRoute: ApiRoute<
	UpdateInventoryInformationPathParams,
	NoQueryParams,
	InventoryInformationChange,
	InventoryInformationView
> = {
	buildUrl: (params) => `/vehicles/${params.inventoryId}/inventory-information`,
	method: "patch",
	path: "/vehicles/:inventoryId/inventory-information",
}
